module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/zh-hans_okinawa-e577c65b453a79a7be68a892adedc0db.jpg";